<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center" v-if="showList">
      <b-col  xl="10">
        <b-card>
          <div slot="header">Job Department 
            <div class="card-header-actions">
              <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
              <button class="btn btn-primary mr-1" @click="exportxls()">
                  <i class="fa fa-file-excel-o"></i>
                  Export
              </button>
              <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
            </div>
          </div>
        <b-row >
          <b-col lg="9">
              <b-input-group >
                  <b-input-group-prepend><span class="pt-2 mr-2">Filter of </span></b-input-group-prepend>
                  <b-form-input v-model="filter.departemen" placeholder="Department"></b-form-input>
                  <b-form-input v-model="filter.division" class="ml-1" placeholder="Division"></b-form-input>
                  <b-form-input v-model="filter.directorate" class="ml-1" placeholder="Directorate"></b-form-input>
              </b-input-group>
          </b-col>
          <b-col md="3">
                <b-row>
                  <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                  <b-button class="btn btn-secondary mr-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
                </b-row>
          </b-col>
        </b-row>

          <b-table
            class="mb-0"
            ref="table"
            outlined  responsive hover small
            style="font-size:smaller;" 
            :items="data"
            :fields="tblFields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"

            @row-clicked="rowClicked"
          >
            <!-- <template v-slot:cell(departno)="data">
              {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
            </template> -->

            <template v-slot:cell(action)="data">
              <div class="text-center">
              <a href="javascript:void(0)" @click.stop="edit(data.item)">
                <i class="fa fa-pencil"></i>
              </a>
              |
              <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
                <i class="fa fa-trash"></i>
              </a>
              </div>
            </template>
          </b-table>
          <b-row class="mt-2">
            <b-col cols="6">
              <div>
                Showing {{(tblData.page - 1) * tblData.limit + 1}}
                to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
                of {{tblData.total}} entries
              </div>
            </b-col>
            <b-col cols="6">            
              <b-pagination
                align="right"
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
            </b-col>
          </b-row>

          <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
            <p class="mb-1">1 record is about to be permanently deleted</p>
            <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
          </b-modal>
        </b-card>
        </b-col>
    </b-row>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card >
          <div slot="header">Job Department - Add/Edit Form </div>
              <b-form-group  label-cols=3  label="Code" >
                  <b-form-input v-model="frmdata.departkd" :state="!$v.frmdata.departkd.$error"></b-form-input>
              </b-form-group>
              <b-form-group  label-cols=3  label="Name" >
                  <b-form-input v-model="frmdata.departemen" :state="!$v.frmdata.departemen.$error"></b-form-input>
              </b-form-group>
              <b-form-group  label-cols=3  label="Division" >
                  <b-form-input v-model="frmdata.division" ></b-form-input>
              </b-form-group>
              <b-form-group  label-cols=3  label="Directorate" >
                  <b-form-input v-model="frmdata.directorate" ></b-form-input>
              </b-form-group>
              <b-form-group  label-cols=3  label="Number" >
                  <b-form-input v-model="frmdata.departno" :state="!$v.frmdata.departno.$error"></b-form-input>
              </b-form-group>
            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
             <b-button variant="secondary" class="mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import crudexport from "../../apis/crudexport";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
        departkd: { required },
        departemen: { required },
        departno: { required },
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showList:true,
      showForm:false,
      frmdata:{departemen: '',division:'', directorate:'' },
      tblData: {
        tablename:'job-department',
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
      },
      filter:{ departemen:'', division:'', directorate:''}
    };
  },
  computed: {
    tblFields(){
      const fields=[
          {
            key: "departkd",
            label: "Code",
            sortable: true
          },
          {
            key: "departemen",
            label: "Name",
            sortable: true
          },
          {
            key: "division",
            label: "Division",
            sortable: true
          },
          {
            key: "directorate",
            label: "Directorat",
            sortable: true
          },
          {
            key: "departno",
            label: "Display Seq#",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          }          
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },

  },
  methods: {
    exportxls: async function() {
        this.isLoading=true;
        try {
            this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            let str ='isdeleted=0';
            if (this.filter.departemen){
              str += str ? '&' : '';
              str = str + 'departemen=%' + encodeURIComponent(this.filter.departemen)+'%';
            }
            if (this.filter.division){
              str += str ? '&' : '';
              str = str + 'division=%' + encodeURIComponent(this.filter.division)+'%';
            }
            if (this.filter.directorate){
              str += str ? '&' : '';
              str = str + 'directorate=%' + encodeURIComponent(this.filter.directorate)+'%';
            }
            this.tblData.customQuery=str;      

            const response = await crudexport.crewdepartemen(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },   
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      let str ='isdeleted=0';
      if (this.filter.departemen){
        str += str ? '&' : '';
        str = str + 'departemen=%' + encodeURIComponent(this.filter.departemen)+'%';
      }
      if (this.filter.division){
        str += str ? '&' : '';
        str = str + 'division=%' + encodeURIComponent(this.filter.division)+'%';
      }
      if (this.filter.directorate){
        str += str ? '&' : '';
        str = str + 'directorate=%' + encodeURIComponent(this.filter.directorate)+'%';
      }
      this.tblData.customQuery=str;      
      const list = await crud.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.frmdata.idlama = data.departid;
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              if (this.frmdata.idlama) {
                await crud.update(
                     {tablename:'job-department', 
                     key:this.frmdata.idlama, 
                     data:{departkd:this.frmdata.departkd, departemen:this.frmdata.departemen,
                     division: this.frmdata.division, directorate:this.frmdata.directorate,
                     departno:this.frmdata.departno}
                      });
              } else {
                await crud.insert(
                  { tablename:'job-department',                      
                     data:{departkd:this.frmdata.departkd, departemen:this.frmdata.departemen,
                     division: this.frmdata.division, directorate:this.frmdata.directorate,
                     departno:this.frmdata.departno}
                  });
              }
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({tablename:'job-department', key:this.model.departid});
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    clearFilter(ctx) {
        this.filter.departemen= '';
        this.filter.division= '';
        this.filter.directorate= '';
        this.refresh();
    },    
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
